import React from 'react';
import { withAnalyticsAppContext } from '../../context/analytics-app-context';
import { isEmpty } from '../../utils/object-utils';
import AnalyticsTable from '../analytics-table/AnalyticsTable';
import './analytics-pages-data.scss';

function AnalyticsPagesData({ appContext }) {
    const { loading } = appContext;
    const { analyticsOverPageData, activeVisitors } = appContext.analyticsData || {};
    const analyticsPageProperties = [
        { property: 'shortUrlFormat', headerText: 'Page URL', isProgressBar: false },
        { property: 'formattedAverageTimeForActiveVisitors', headerText: 'Avg. Visitor Time', isProgressBar: false },
        { property: 'activeVisitors', headerText: 'Active Visitors', isProgressBar: false },
        { property: 'visitorsThatAcceptedCookies', headerText: 'Accepted All Cookies', isProgressBar: false },
        { property: 'visitorsThatRejectedCookies', headerText: 'Refused Some Cookies', isProgressBar: false },
        { property: 'visitedPercentage', headerText: `Most Visited out of ${activeVisitors}`, isProgressBar: true }
    ];

    return (
        <div className='analytics-grid-item-root analytics-grid-pages-root analytics-component grid-item'>
            <div className='analytics-grid-item-data analytics-grid-pages-data'>
                <div className='card-header-root'>
                    <div className='card-header-content'>
                        <span className='card-header-title'>
                            <h6> {'Analytics over page'}</h6>
                        </span>
                    </div>
                </div>
                <div className='card-body'>
                    {loading && 'Loading...'}
                    {loading || isEmpty(analyticsOverPageData) ?
                        null :
                        <AnalyticsTable tableProperties={analyticsPageProperties} tableData={analyticsOverPageData}></AnalyticsTable>}
                </div>
            </div >
        </div>
    );
}

export default withAnalyticsAppContext(AnalyticsPagesData);
